import { Component, EventEmitter, forwardRef, HostListener, input, Input, Output } from '@angular/core';
import { sizeType } from '../../interfaces/enumSizeType';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rr-checkbox',
  standalone: false,
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() checked: boolean = false;
  @Input() indeterminate: boolean = false;
  @Input() disabled: boolean = false;
  @Input() size: string = sizeType.Medium;
  @Input() FormControl: FormControl = new FormControl();

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  ngOnInit() {

    this.FormControl.valueChanges.subscribe((value) => {
      this.onChange(value);
    });

  }
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.disabled === true) return;
    this.checked = !this.checked;
    this.FormControl.setValue(this.checked);

  }

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if (this.disabled === true) return;
    if (event.key === 'Enter' || event.key === ' ') {
      this.checked = !this.checked;
      this.FormControl.setValue(this.checked);
    }
  }

  writeValue(value: any): void {
    this.FormControl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
